export default __webpack_public_path__ + "static/media/cain3.1f9f06a6.jpg";